import { gql } from '@apollo/client';

export const CREATE_LIVE_EVENT_SUBSCRIPTION = gql`
    mutation createLiveEventSubscription($org_id: Int!, $eventId: Int!) {
        orgMutation (organization_id: $org_id) {
            subscribeLiveEvent(live_event_id: $eventId) {
                successful
                message
            }
        }
    }
`;

export const DELETE_LIVE_EVENT_SUBSCRIPTION = gql`mutation unSubscribeLiveEvent($organization_id: Int! $live_event_id: Int!) {
    orgMutation (organization_id: $organization_id) {
        unsubscribeLiveEvent(live_event_id: $live_event_id) {
            successful
            message
        }
    }
}`;

export const GET_EVENTS = gql`query getEvents($org_id: Int!) {
    Organization (id: $org_id) {
        id
        liveEvents {
            id
            name
            thumbnail
            status
            schedule_start
            schedule_end

            iHaveSubscribed: orgHasSubscribed(org_id: $org_id, parents: false, me: true, children: false)
            subscribed: orgHasSubscribed(org_id: $org_id, parents: true, me: true, children: false)
            subscriptions: orgSubscriptions(org_id: $org_id) { id created_at subscribed_by{ id name } Organization { id name }}
        }
    }
}`;
